import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { withTracking } from '../../observability';
import { Ticker } from './Ticker';

export default createBuilderModule(
  withChildren(withTracking(Ticker, { sectionName: 'Ticker' })),
  {
    name: 'Ticker',
    image: 'https://cdn.zappy.app/8f021029c383bf02f190aae8bfca7c2f.svg',
    inputs: [
      {
        name: 'speed',
        type: 'string',
        enum: ['slow', 'normal', 'fast'],
        defaultValue: 'normal',
      },
      {
        name: 'reversed',
        type: 'boolean',
      },
      {
        name: 'compact',
        type: 'boolean',
      },
    ],
  },
);
